export default __webpack_public_path__ + "assets/daqastra.66c1a0c1.png";